import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incidents-rolle-berechtigung';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsRolleBerechtigungEffects {

    IncidentsRolleBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENTS_ROLLE_BERECHTIGUNG),
        mergeMap((x: ac.GetIncidentsRolleBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentsRolleBerechtigung(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentsRolleBerechtigungErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentsRolleBerechtigungFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
